const SET_ALL_PROGRESS = 'progress/SET_ALL_PROGRESS'
const SUBTRACT_ONE_TO_NOTIFICATIONS_INBOX =
  'progress/SUBTRACT_ONE_TO_NOTIFICATIONS_INBOX'

export {SET_ALL_PROGRESS, SUBTRACT_ONE_TO_NOTIFICATIONS_INBOX}
